import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import parse from "html-react-parser";
import './heading.scss';

const Heading = ({ activeSubmenu }) => {
  const [headingText, setHeadingText] = useState("");
  useEffect(() => {
    const currentSubmenu =
      window.config &&
      window.config.allSubmenu &&
      window.config.allSubmenu.find(
        (item) => item.id === activeSubmenu
      );

    const heading = currentSubmenu.headingText;
    let text = "";
    const selectedProductType =
      window.selectedConfig &&
      window.selectedConfig.ProductType &&
      window.selectedConfig.ProductType.toLowerCase();

    // Function to filter array/object by ProductType
    const filterByProductType = (item) => {
      if (!item.configType || !item.configType.ProductType) return true;
      return item.configType.ProductType
        .map(p => p.toLowerCase())
        .includes(selectedProductType);
    };

    // Case 1: heading is a simple string
    if (typeof heading === "string") {
      text = heading;
    }
    // Case 2: heading is an array of objects 
    else if (Array.isArray(heading)) {
      const filtered = heading.filter(filterByProductType);
      text = filtered.length > 0 ? filtered[0].text : ""; // first matching item
    }
    // Case 3: heading is a single object
    else if (typeof heading === "object") {
      text = filterByProductType(heading) ? heading.text : ""; // single object
    }

    setHeadingText(text);
  }, [activeSubmenu]);

  const container = document.getElementById("menuHeadingContainer");
  if (!container) return null;

  const content = (
    <div className={`headingWrapper ${window.isMobIsipadIsPotrait ? "mobile" : "desktop"}`} id={activeSubmenu}
    >
      {headingText && <p>{parse(headingText)}</p>}
    </div>
  );

  return ReactDOM.createPortal(content, container);
};

export default Heading;
